{
  "metadata": {
    "id": "lucent-orng-light",
    "name": "Lucent Orng",
    "description": "Портировано из темы «Lucent Orng» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "lucent-orng.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/lucent-orng.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 31.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.441,
      "paletteMaxS": 0.514,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.7,
      "syntaxVsTextMinDeltaE": 26.5,
      "chartsMinDeltaE": 23.7,
      "textSeparationDeltaE": 20.0,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "number",
          "deltaE": 0.0
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#EC5B2B",
      "hover": "#d45227",
      "active": "#c24b23",
      "foreground": "#000000",
      "muted": "#ec5b2b80",
      "emphasis": "#EC5B2B"
    },
    "surface": {
      "background": "#fff5f0",
      "foreground": "#1a1a1a",
      "muted": "#cfc7c3",
      "mutedForeground": "#454545",
      "elevated": "#b8b1ae",
      "elevatedForeground": "#1a1a1a",
      "raised": "#9c9693",
      "raisedForeground": "#1a1a1a",
      "overlay": "#fff5f033",
      "subtle": "#e7ded9"
    },
    "interactive": {
      "border": "#958f8d",
      "borderHover": "#bfb8b4",
      "borderFocus": "#EC5B2B",
      "selection": "#1a1a1a24",
      "selectionForeground": "#1a1a1a",
      "focus": "#ec5b2b59",
      "focusRing": "#ec5b2b47",
      "cursor": "#1a1a1a",
      "hover": "#1a1a1a17",
      "active": "#1a1a1a24"
    },
    "status": {
      "error": "#d1383d",
      "errorForeground": "#ffffff",
      "errorBackground": "#d1383d1a",
      "errorBorder": "#d1383d59",
      "warning": "#c83f12",
      "warningForeground": "#ffffff",
      "warningBackground": "#c83f121a",
      "warningBorder": "#c83f1259",
      "success": "#0062d1",
      "successForeground": "#ffffff",
      "successBackground": "#0062d11a",
      "successBorder": "#0062d159",
      "info": "#2c7986",
      "infoForeground": "#ffffff",
      "infoBackground": "#2c79861a",
      "infoBorder": "#2c798659"
    },
    "pr": {
      "open": "#0062d1",
      "draft": "#545454",
      "blocked": "#c83f12",
      "merged": "#c94d24",
      "closed": "#d1383d"
    },
    "syntax": {
      "base": {
        "background": "#cfc7c3",
        "foreground": "#1a1a1a",
        "comment": "#545454",
        "keyword": "#99300e",
        "string": "#0051ad",
        "number": "#99300e",
        "function": "#215a63",
        "variable": "#9d2428",
        "type": "#664d12",
        "operator": "#215a63"
      },
      "tokens": {
        "commentDoc": "#545454",
        "stringEscape": "#215a63",
        "keywordImport": "#99300e",
        "storageModifier": "#99300e",
        "functionCall": "#215a63",
        "method": "#215a63",
        "variableProperty": "#215a63",
        "variableOther": "#9d2428",
        "variableGlobal": "#99300e",
        "variableLocal": "#215a63",
        "parameter": "#9d2428",
        "constant": "#99300e",
        "class": "#664d12",
        "className": "#664d12",
        "interface": "#664d12",
        "struct": "#664d12",
        "enum": "#664d12",
        "typeParameter": "#664d12",
        "namespace": "#664d12",
        "module": "#99300e",
        "tag": "#99300e",
        "jsxTag": "#99300e",
        "tagAttribute": "#215a63",
        "tagAttributeValue": "#0051ad",
        "boolean": "#99300e",
        "decorator": "#99300e",
        "label": "#215a63",
        "regexp": "#0051ad"
      }
    },
    "charts": {
      "series": [
        "#EC5B2B",
        "#2c7986",
        "#0062d1",
        "#c87c12",
        "#d1383d"
      ]
    },
    "chat": {
      "background": "#fff5f0",
      "userMessage": "#1a1a1a",
      "userMessageBackground": "#b8b1ae",
      "assistantMessage": "#1a1a1a",
      "assistantMessageBackground": "#cfc7c3",
      "timestamp": "#545454",
      "divider": "#958f8d",
      "typing": "#545454"
    },
    "loading": {
      "spinner": "#EC5B2B",
      "spinnerTrack": "#cfc7c3",
      "skeleton": "#cfc7c3",
      "shimmer": "#c4bdb9"
    },
    "tools": {
      "background": "#cfc7c3",
      "border": "#958f8d",
      "headerHover": "#c6bebb",
      "icon": "#c83f12",
      "title": "#1a1a1a",
      "description": "#545454",
      "edit": {
        "added": "#0062d1",
        "addedBackground": "#0062d11a",
        "removed": "#d1383d",
        "removedBackground": "#d1383d1a",
        "modified": "#2c7986",
        "modifiedBackground": "#2c79861a",
        "lineNumber": "#545454"
      }
    },
    "markdown": {
      "heading1": "#1a1a1a",
      "heading2": "#1a1a1a",
      "heading3": "#1a1a1a",
      "heading4": "#1a1a1a",
      "link": "#c83f12",
      "linkHover": "#be4a23",
      "inlineCode": "#0051ad",
      "inlineCodeBackground": "#cfc7c3",
      "blockquote": "#545454",
      "blockquoteBorder": "#958f8d",
      "listMarker": "#ec5726",
      "bold": "#1a1a1a",
      "italic": "#1a1a1ae6",
      "strikethrough": "#545454",
      "hr": "#958f8d"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393f",
        "foreground": "#ffffff",
        "contrast": 7.67
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bc7545",
        "foreground": "#000000",
        "contrast": 5.77
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d5c196",
        "foreground": "#000000",
        "contrast": 11.9
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c1c354",
        "foreground": "#000000",
        "contrast": 11.2
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#658f41",
        "foreground": "#000000",
        "contrast": 5.56
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#51c04f",
        "foreground": "#000000",
        "contrast": 9.0
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dca5",
        "foreground": "#000000",
        "contrast": 13.0
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e7b",
        "foreground": "#000000",
        "contrast": 5.39
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#92d3db",
        "foreground": "#000000",
        "contrast": 12.56
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#387593",
        "foreground": "#ffffff",
        "contrast": 5.08
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#354887",
        "foreground": "#ffffff",
        "contrast": 8.65
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3f3eb3",
        "foreground": "#ffffff",
        "contrast": 8.23
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a990d0",
        "foreground": "#000000",
        "contrast": 7.59
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b446ba",
        "foreground": "#ffffff",
        "contrast": 4.64
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b75",
        "foreground": "#ffffff",
        "contrast": 7.09
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d1919f",
        "foreground": "#000000",
        "contrast": 8.26
      }
    ]
  }
}
